import React from 'react';
import BadgeBase from './BadgeBase';
import TEBadgeSignal from '../../types/TEBadgeSignal';

const Brand = (props) => <BadgeBase {...props} signal={TEBadgeSignal.Overlay} />;

export default Brand;
